const RELEVANT_DAY_COUNT = 60;
function getDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
function getFirstRelevantDate() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - RELEVANT_DAY_COUNT);
    return date;
}
function pruneVisitCounts(visitCounts) {
    const firstRelevantDateKey = getDateKey(getFirstRelevantDate());
    const todayKey = getDateKey(new Date());
    return Object.fromEntries(Object.entries(visitCounts)
        .filter(([dateKey, counts]) => dateKey >= firstRelevantDateKey && dateKey <= todayKey && counts && typeof counts === 'object' && !Array.isArray(counts))
        .map(([dateKey, counts]) => [dateKey, { ...counts }]));
}
export function recordMainMenuVisit(storedVisitCounts, menuItemKey) {
    const visitCounts = pruneVisitCounts(storedVisitCounts);
    const todayKey = getDateKey(new Date());
    const todayCounts = visitCounts[todayKey] || {};
    todayCounts[menuItemKey] = (Number(todayCounts[menuItemKey]) || 0) + 1;
    visitCounts[todayKey] = todayCounts;
    return visitCounts;
}
export function getMainMenuVisitTotals(storedVisitCounts) {
    const visitCounts = pruneVisitCounts(storedVisitCounts);
    const todayKey = getDateKey(new Date());
    const totals = {};
    Object.entries(visitCounts).forEach(([dateKey, counts]) => {
        if (dateKey === todayKey) {
            return;
        }
        Object.entries(counts).forEach(([menuItemKey, count]) => {
            totals[menuItemKey] = (totals[menuItemKey] || 0) + (Number(count) || 0);
        });
    });
    return totals;
}
